import styled from '@emotion/styled'

export const TimerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2em;
  padding-bottom: 6em;
  align-items: flex-start;

  &[data-gridlayout=true] {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    gap: 1em;
    padding-bottom: 4em;
    grid-template-columns: 1fr;
    
    &[data-gridlayout=true] {
      grid-template-columns: 1fr;
    }
  }
`

export const FAB = styled.a`
  position: fixed;
  bottom: 3rem;
  right: 3rem;
  margin: 0;
  padding: .5em 1.2em;
  box-sizing: border-box;
  font: inherit;
  color: inherit;
  border: 2px solid currentColor;
  background: ${props => props.theme.background};
  border-radius: 10em;
  display: flex;
  align-items: center;
  gap: .5em;
  font-size: 1.2em;
  cursor: pointer;
  z-index: 90;
  text-decoration: none;

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    bottom: 1rem;
    right: 1rem;
  }
`